export default {"src":"/_next/static/media/alert--red.a6da8c46.svg","height":51,"width":51};